export default {
  ABW: { x: "-69.9742007504655", y: "12.5169352691064" },
  AFG: { x: "66.0084476872122", y: "33.8362670719586" },
  AGO: { x: "17.5643363041574", y: "-12.3305127449851" },
  AIA: { x: "-63.0574143280804", y: "18.2245225844655" },
  ALB: { x: "20.0538191970435", y: "41.1424820603972" },
  AND: { x: "1.56075624104631", y: "42.5413265250734" },
  ARE: { x: "54.3071499765538", y: "23.9018053870066" },
  ARG: { x: "-65.1551605364817", y: "-35.1865657515494" },
  ARM: { x: "44.9316057532883", y: "40.2877203381861" },
  ASM: { x: "-170.716153583169", y: "-14.3048138844022" },
  ATA: { x: "82.507095", y: "-84.968576" },
  ATG: { x: "-61.7896001978274", y: "17.0747941867421" },
  AUS: { x: "134.354074903254", y: "-25.5735771391628" },
  AUT: { x: "14.1306728873938", y: "47.5856569205211" },
  AZE: { x: "47.6606630903764", y: "40.3457051199892" },
  BDI: { x: "29.8750826944729", y: "-3.35742533642172" },
  BEL: { x: "4.63996050762213", y: "50.6374616353487" },
  BEN: { x: "2.32874073085955", y: "9.64121668505945" },
  BES: { x: "-68.2876100984292", y: "12.1864903326039" },
  BFA: { x: "-1.75552769525805", y: "12.269553913823" },
  BGD: { x: "90.2273400097009", y: "23.8814198484226" },
  BGR: { x: "25.2175125117746", y: "42.7685226143645" },
  BHR: { x: "50.5466193475777", y: "26.052784294496" },
  BHS: { x: "-78.0397299462987", y: "24.7038182896034" },
  BIH: { x: "17.7734080203463", y: "44.1717340564072" },
  BLM: { x: "-62.8326196250664", y: "17.9055845218281" },
  BLR: { x: "28.0335663949233", y: "53.5318804783204" },
  BLZ: { x: "-88.704043448262", y: "17.2014715213926" },
  BMU: { x: "-64.7617674596749", y: "32.3109436228402" },
  BOL: { x: "-64.6847537287432", y: "-16.706876810522" },
  BRA: { x: "-53.1146378943768", y: "-10.8385209105043" },
  BRB: { x: "-59.5612177482308", y: "13.1810538267698" },
  BRN: { x: "114.59802902407", y: "4.49332610620936" },
  BTN: { x: "90.4044602001727", y: "27.4217565615654" },
  BVT: { x: "3.413142", y: "-54.419265" },
  BWA: { x: "23.7989867328197", y: "-22.1857723210307" },
  CAF: { x: "20.464809197141", y: "6.56632186012999" },
  CAN: { x: "-102.356464062606", y: "57.9394371731592" },
  CCK: { x: "96.8381226203874", y: "-12.1681406369058" },
  CHE: { x: "8.21535365740733", y: "46.7989568697925" },
  CHL: { x: "-71.2456794106527", y: "-35.4519491286351" },
  CHN: { x: "103.882768426774", y: "36.6226659017784" },
  CIV: { x: "-5.56947458170674", y: "7.62846920092167" },
  CMR: { x: "12.7369841653872", y: "5.69305820583048" },
  COD: { x: "23.6456634750562", y: "-2.8796457881227" },
  COG: { x: "15.2183361558924", y: "-0.838879989114628" },
  COK: { x: "-159.786510461973", y: "-21.2193439809185" },
  COL: { x: "-73.0813422332888", y: "3.90930726578987" },
  COM: { x: "43.3397276474312", y: "-11.6554237541233" },
  CPV: { x: "-23.6368462083653", y: "15.0817986539691" },
  CRI: { x: "-84.1920110268435", y: "9.97465532027396" },
  CUB: { x: "-78.9584958594086", y: "21.6140319711602" },
  CUW: { x: "-68.9713056071945", y: "12.1938210892868" },
  CXR: { x: "105.662522712536", y: "-10.4925233522574" },
  CYM: { x: "-81.2517988079829", y: "19.3182865584318" },
  CYP: { x: "33.2274916040799", y: "35.0479596593635" },
  CZE: { x: "15.3141031032203", y: "49.7324482055165" },
  DEU: { x: "10.3707885619977", y: "51.0871036365126" },
  DJI: { x: "42.5664536523574", y: "11.7501558755494" },
  DMA: { x: "-61.3569175920735", y: "15.4364404854133" },
  DNK: { x: "9.37460689806583", y: "56.226976900983" },
  DOM: { x: "-70.5003429257442", y: "18.8992328636346" },
  DZA: { x: "2.65309137676693", y: "28.1488896573608" },
  ECU: { x: "-78.3872175800361", y: "-1.44886237614453" },
  EGY: { x: "29.860389045854", y: "26.4925730003718" },
  ERI: { x: "38.844833364022", y: "15.3551106215457" },
  ESH: { x: "-13.145323", y: "24.658451" },
  ESP: { x: "-3.5629098221017", y: "40.3895444281165" },
  EST: { x: "25.831378152451", y: "58.6841712453881" },
  ETH: { x: "39.6005510348543", y: "8.62295173649639" },
  FIN: { x: "26.2878253987307", y: "64.5097206967368" },
  FJI: { x: "177.975198918765", y: "-17.8241340765871" },
  FLK: { x: "-58.7541267919898", y: "-51.7348019894162" },
  FRA: { x: "2.45218885908909", y: "46.62065825598" },
  FRO: { x: "-6.98717290686576", y: "62.1371416618062" },
  FSM: { x: "158.2340190977", y: "6.88268807401705" },
  GAB: { x: "11.7909187877054", y: "-0.591611902102822" },
  GBR: { x: "-2.51865491499821", y: "53.9476089916564" },
  GEO: { x: "43.5075263316856", y: "42.1688007767014" },
  GHA: { x: "-1.2165238314389", y: "7.95395472368879" },
  GIB: { x: "-5.34670032361925", y: "36.1294636705136" },
  GIN: { x: "-10.9430612660251", y: "10.4346490465873" },
  GLP: { x: "-61.541243", y: "16.253642" },
  GMB: { x: "-15.3975820260462", y: "13.4497295585549" },
  GNB: { x: "-14.9290076296997", y: "12.0568851288004" },
  GNQ: { x: "10.4674104099759", y: "1.56517589068906" },
  GRC: { x: "22.5818597139489", y: "39.4749980798888" },
  GRD: { x: "-61.6790389943216", y: "12.1177266314475" },
  GRL: { x: "-41.4353547813485", y: "74.7593333174778" },
  GTM: { x: "-90.3601574580492", y: "15.696016481158" },
  GUF: { x: "-53.244555", y: "3.922512" },
  GUM: { x: "144.771939120218", y: "13.4437930173836" },
  GUY: { x: "-58.9802874113048", y: "4.79281512489122" },
  HKG: { x: "114.16083411616", y: "22.4245023594681" },
  HMD: { x: "73.5052101889518", y: "-53.0888170257529" },
  HND: { x: "-86.6251624459565", y: "14.8184284338705" },
  HRV: { x: "16.4219855054661", y: "45.1559135644219" },
  HTI: { x: "-72.6773629678463", y: "18.9350743688359" },
  HUN: { x: "19.3967592672731", y: "47.1632436865772" },
  IDN: { x: "114.018809105905", y: "-0.191358079506278" },
  IND: { x: "79.2373831469953", y: "22.7949060133834" },
  IOT: { x: "72.4262357159874", y: "-7.34679700863796" },
  IRL: { x: "-8.13826279972853", y: "53.1766958350729" },
  IRN: { x: "54.2756247624479", y: "32.5768439789222" },
  IRQ: { x: "43.7449770162436", y: "33.0398037798302" },
  ISL: { x: "-18.5963957527647", y: "64.9984119304205" },
  ISR: { x: "34.9498017232709", y: "31.3446550849003" },
  ITA: { x: "12.1548957646587", y: "43.5230320489388" },
  JAM: { x: "-77.3188104659213", y: "18.1552263884287" },
  JOR: { x: "36.7709218024255", y: "31.2455741396677" },
  JPN: { x: "137.972471284071", y: "36.6505029605944" },
  KAZ: { x: "67.2893105499039", y: "48.1560382213193" },
  KEN: { x: "37.8371971078439", y: "0.527020554423723" },
  KGZ: { x: "74.5416693868243", y: "41.4619186595075" },
  KHM: { x: "104.905251945801", y: "12.7180062718642" },
  KIR: { x: "-157.370747952017", y: "1.84982603508269" },
  KNA: { x: "-62.7579752715547", y: "17.3322532884309" },
  KOR: { x: "127.867182669074", y: "36.4598236010378" },
  KWT: { x: "47.5649905688946", y: "29.3200924123404" },
  LAO: { x: "103.737872200403", y: "18.5023014728186" },
  LBN: { x: "35.8799365603507", y: "33.920359328336" },
  LBR: { x: "-9.31986399319032", y: "6.45223255456447" },
  LBY: { x: "18.0096051210001", y: "27.0302779757864" },
  LCA: { x: "-60.9703165311976", y: "13.9026705469139" },
  LKA: { x: "80.7051536039352", y: "7.60935968970721" },
  LSO: { x: "28.2286229250267", y: "-29.5797304442089" },
  LTU: { x: "23.8940711499442", y: "55.3267336189944" },
  LUX: { x: "6.07176396725844", y: "49.7668242757693" },
  LVA: { x: "24.9086224274626", y: "56.8518194796155" },
  MAC: { x: "113.5564553795", y: "22.1371581683333" },
  MAR: { x: "-6.29346944785197", y: "31.843002405391" },
  MDA: { x: "28.4613971304096", y: "47.1951014890209" },
  MDG: { x: "46.704131476164", y: "-19.3768956726748" },
  MDV: { x: "73.5075535036973", y: "4.19079418269773" },
  MEX: { x: "-102.51051581758", y: "23.9424332509279" },
  MHL: { x: "171.205810874621", y: "7.09948132244972" },
  MKD: { x: "21.683830410055", y: "41.5950049267038" },
  MLI: { x: "-3.53907941200309", y: "17.3441627910198" },
  MLT: { x: "14.4413616284583", y: "35.8906106307668" },
  MMR: { x: "96.488799510098", y: "21.2138454603909" },
  MNE: { x: "19.2385002864373", y: "42.7858180546185" },
  MNG: { x: "103.05628666206", y: "46.8258060660135" },
  MNP: { x: "145.741369375193", y: "15.183666850927" },
  MOZ: { x: "35.537461074868", y: "-17.2690763988724" },
  MRT: { x: "-10.3421164022792", y: "20.2563219883547" },
  MSR: { x: "-62.1873987827751", y: "16.7375235650015" },
  MTQ: { x: "-60.998127", y: "14.677257" },
  MUS: { x: "57.5695667656926", y: "-20.2793236795233" },
  MWI: { x: "34.2892877224567", y: "-13.2191788128162" },
  MYS: { x: "114.721262780191", y: "3.61476088804488" },
  MYT: { x: "45.14586", y: "-12.810617" },
  NAM: { x: "17.2111331974411", y: "-22.129246638635" },
  NCL: { x: "165.4870424717", y: "-21.3255506918479" },
  NER: { x: "9.38603399667635", y: "17.4184637710189" },
  NFK: { x: "167.955169332559", y: "-29.0349751031425" },
  NGA: { x: "8.09148996191812", y: "9.5969713097199" },
  NIC: { x: "-85.0342607703693", y: "12.845120511304" },
  NIU: { x: "-169.86934604203", y: "-19.0489197558885" },
  NLD: { x: "5.6392731810822", y: "52.2822831451395" },
  NOR: { x: "14.0215083190799", y: "64.2388038984741" },
  NPL: { x: "83.9162534432098", y: "28.2479221852103" },
  NRU: { x: "166.933131929431", y: "-0.520782884754556" },
  NZL: { x: "170.520004754811", y: "-43.9842302986628" },
  OMN: { x: "56.0859298355888", y: "20.5726739226562" },
  PAK: { x: "69.3414179745031", y: "29.9487285087902" },
  PAN: { x: "-80.1070892863815", y: "8.52247956050854" },
  PCN: { x: "-128.317080700203", y: "-24.3660317242272" },
  PER: { x: "-74.3778819524601", y: "-9.15432284211006" },
  PHL: { x: "121.41797266038", y: "15.9533613124827" },
  PLW: { x: "134.580148708965", y: "7.5138186592441" },
  PNG: { x: "144.249807113402", y: "-6.61207343927265" },
  POL: { x: "19.394322139756", y: "52.1247718188779" },
  PRK: { x: "127.186725650954", y: "40.1522103148545" },
  PRT: { x: "-7.97469680472659", y: "39.6808231577746" },
  PRY: { x: "-58.3984228076702", y: "-23.2275188156358" },
  PSE: { x: "35.2449557219813", y: "31.9453854367684" },
  PYF: { x: "-149.420483463503", y: "-17.6639140323625" },
  QAT: { x: "51.1868312935873", y: "25.3130745940898" },
  REU: { x: "55.521605", y: "-21.116016" },
  ROU: { x: "24.9729418551502", y: "45.8534640978308" },
  RUS: { x: "99.0708495596224", y: "61.6611318114413" },
  RWA: { x: "29.9190607046576", y: "-1.99275052785932" },
  SAU: { x: "44.5386358557821", y: "24.1240967199425" },
  SDN: { x: "29.9482343772199", y: "16.0224747642791" },
  SEN: { x: "-14.4713060277065", y: "14.3677885788867" },
  SGP: { x: "103.813467658105", y: "1.35892102031202" },
  SGS: { x: "-36.683671479951", y: "-54.3676752098513" },
  SHN: { x: "-5.7173644716926", y: "-15.9590979386567" },
  SLB: { x: "160.170302761965", y: "-9.62260939082634" },
  SLE: { x: "-11.7873429012958", y: "8.57191081612961" },
  SLV: { x: "-88.8723245964675", y: "13.7364528137225" },
  SMR: { x: "12.4422225587343", y: "43.9364661944734" },
  SOM: { x: "45.8508314556225", y: "6.06265158602042" },
  SPM: { x: "-56.3244198059086", y: "46.9516119992167" },
  SRB: { x: "20.7904024710083", y: "44.2213759212014" },
  SSD: { x: "30.3268804300248", y: "7.27005673162008" },
  STP: { x: "6.60763536204819", y: "0.235564718794675" },
  SUR: { x: "-55.9110713607808", y: "4.13124497909791" },
  SVK: { x: "19.4803829712221", y: "48.704935301707" },
  SVN: { x: "14.8080896248095", y: "46.1161109843355" },
  SWE: { x: "16.7439916194109", y: "62.830187694457" },
  SWZ: { x: "31.4800241029928", y: "-26.5619143490273" },
  SXM: { x: "-63.0701327003458", y: "18.04063048366" },
  SYC: { x: "55.4671258872254", y: "-4.67607717156196" },
  SYR: { x: "38.4859423774255", y: "35.0095166599305" },
  TCA: { x: "-71.7418844331005", y: "21.8092601655106" },
  TCD: { x: "18.6462511140026", y: "15.3330781050204" },
  TGO: { x: "0.962271599702739", y: "8.52678820598477" },
  THA: { x: "101.008746476514", y: "15.1372145888008" },
  TJK: { x: "71.0162890091869", y: "38.5282274436557" },
  TKL: { x: "-171.194580934581", y: "-9.34614316632113" },
  TKM: { x: "59.3774676959535", y: "39.1159230147708" },
  TLS: { x: "125.936595807241", y: "-8.80372678225961" },
  TON: { x: "-175.204632761055", y: "-21.1719073081728" },
  TTO: { x: "-61.2939369278173", y: "10.4218594970878" },
  TUN: { x: "9.5487974308444", y: "34.1198272072907" },
  TUR: { x: "35.4235440454358", y: "38.9895797853009" },
  TUV: { x: "179.205007389275", y: "-8.50406855813181" },
  TWN: { x: "120.964347", y: "23.753332" },
  TZA: { x: "34.7985325769371", y: "-6.27556692894508" },
  UGA: { x: "32.3670398526863", y: "1.27569119247884" },
  UKR: { x: "31.3856631756325", y: "48.9981893780954" },
  URY: { x: "-56.0171550954244", y: "-32.7982107490762" },
  USA: { x: "-99.1444409457414", y: "39.5280192988516" },
  UZB: { x: "63.131908992557", y: "41.7577908405957" },
  VAT: { x: "12.4534177294336", y: "41.9033124691455" },
  VCT: { x: "-61.1939749296459", y: "13.2565008662145" },
  VEN: { x: "-66.1837082213568", y: "7.11737971066783" },
  VGB: { x: "-64.6216643411999", y: "18.4241006665443" },
  VNM: { x: "106.300652180058", y: "16.657657094627" },
  VUT: { x: "166.853774657612", y: "-15.231483856736" },
  WLF: { x: "-176.161927918085", y: "-13.2818625382409" },
  WSM: { x: "-172.438242938532", y: "-13.6305469833756" },
  XKV: { x: "20.8737431935159", y: "42.5728833853102" },
  YEM: { x: "47.5419466103921", y: "15.9350501204109" },
  ZAF: { x: "25.083135268106", y: "-28.9950709308261" },
  ZMB: { x: "27.7742123347767", y: "-13.4601100183897" },
  ZWE: { x: "29.8518846205909", y: "-19.0025367099994" },
} as const;
